import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTranslatedActivityType } from "PFApp/activities/show/hooks/use_translated_activity_type";
import { Button } from "PFComponents/button";
import { Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { EMPTY_ACTIVITY_HISTORY_FILTERS, useActivityHistoryContext } from "../../context";
import { hasActiveFilters } from "../../helpers";
import { useHistoryTabEvents } from "../../hooks/use_history_tab_events";
import css from "./history_empty_state.module.scss";

const HistoryEmptyStateContent = () => {
  const activity = useCurrentActivity();
  const { error, isLoading } = useHistoryTabEvents();
  const { filters, setFilters } = useActivityHistoryContext();
  const taskName = useTranslatedActivityType(activity);

  const { t } = useTranslation("activities", { keyPrefix: "show.history" });

  const isUnauthorized = error?.response?.status === 422;

  if (isLoading) {
    return <LoadingDots circlesEnabled circleSize="sm" />;
  }

  if (isUnauthorized) {
    return <Typography variant="h4">{t("modal.unauthorized", { task: taskName })}</Typography>;
  }

  const isFiltered = hasActiveFilters(filters);

  return (
    <>
      <Typography variant="h4">
        {isFiltered ? t("modal.noFilteredResults") : t("modal.missingData", { task: taskName })}
      </Typography>
      {isFiltered && (
        <Button onClick={() => setFilters(EMPTY_ACTIVITY_HISTORY_FILTERS)}>{t("filters.clearAll")}</Button>
      )}
    </>
  );
};

export const HistoryEmptyState = () => (
  <Stack gap="spacingLg" center className={css.info}>
    <HistoryEmptyStateContent />
  </Stack>
);
